import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function followerReducer(state = initialState.followers, action) {
    switch (action.type) {
        case types.LOAD_NETWORK_FOLLOWERS_SUCCESS:
            return action.users;
        case types.NETWORK_REMOVE_FOLLOWING_RIDER:
            if (state.results) {
                state.results.map((user, idx) => {
                    if (user.userId.toLowerCase() == action.user.id.toLowerCase()) {
                        state.results.splice(idx, 1);
                    }
                })
                return {
                    ...state,
                    results: state.results,
                    totalResults: state.totalResults - 1
                };
            }
            return state;
        case types.NETWORK_BLOCK_RIDER:
            if (state.results) {
                state.results.map((user) => {
                    if (user.userId.toLowerCase() == action.user.id.toLowerCase()) {
                        user.blocked = true;
                    }
                })
                return {
                    ...state,
                    results: state.results
                };
            }
            return state;
        case types.NETWORK_UNBLOCK_RIDER:
            if (state.results) {
                state.results.map((user) => {
                    if (user.userId.toLowerCase() == action.user.id.toLowerCase()) {
                        user.blocked = false;
                    }
                })
                return {
                    ...state,
                    results: state.results
                };
            }
            return state;
        case types.LOGOUT_SUCCESS:
            return initialState.followers;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/followerReducer.js